<div class="chat-content rtl-ps-none">
	<div class="timeline-wrapper" [ngStyle]="{
'height': 'calc(100vh - 254px)',
'max-height': 'calc(100vh - 254px)',
'overflow-y': 'auto',
'padding-top': '6rem',
'margin-top': '4px'
	}" [perfectScrollbar]="{ suppressScrollX: true }" ngxInfiniteScroller strategy="scrollingToTop"
		(onScrollUp)="onScroll()">
		<span *ngIf="loadingUp" class="loader-bubble loader-bubble-info ml-4 mt-n2"></span>
		<ul class="timeline clearfix">
			<li class="timeline-line"></li>
			<li class="timeline-item" *ngFor="let item of sharedFiles" style="margin-top: -5rem; width: 51%">
				<div class="timeline-badge">
					<i class="badge-icon text-white i-File-Cloud bg-info"></i>
				</div>
				<div class="timeline-card card mx-2">
					<div class="card-body">
						<div class="card-body text-center">
							<div class="avatar box-shadow-2 mb-3 p-2 d-inline-block" *ngIf="isUrlImage(item.url)">
								<img [src]="item.url" alt="{{ item.name }}" style="height: 15rem" />
							</div>
							<h5 class="m-0">{{ item.name }}</h5>
							<p class="mt-0">{{ item.description }}</p>
							<p>
								{{ item.createdDate | localizedDate: 'full' }}
							</p>
							<a href="{{ item.url }}" target="_blank" class="btn btn-primary btn-rounded text-white"
								data-toggle="tooltip" data-placement="bottom" title="{{'Download' | translate}}">
								<i class="i-Download"></i>
								{{ 'Download' | translate }}
							</a>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<ul class="timeline clearfix">
			<li class="timeline-line"></li>
			<li class="timeline-group text-center">
				<span *ngIf="loading" class="loader-bubble loader-bubble-info ml-4 mt-n2"></span>
			</li>
		</ul>
		<ul class="timeline clearfix">
			<li class="timeline-line"></li>
			<li class="timeline-group text-center">
				<button class="btn btn-icon-text btn-warning">
					<i class="i-Calendar-4"></i> {{ userJoinDate | localizedDate: 'yyyy' }}
				</button>
			</li>
		</ul>
	</div>
</div>